import React from 'react';
import Conditional from '../../common/conditional';

import usePagination from '../../../hooks/usePagination';
import css from './pagination.module.scss';

import * as models from '../../../utils/models';

const Pagination: React.FC<models.Pagination> = (props) => {
	const pagination = usePagination(props.itemsCount, props.pageSize);
	if (!pagination) return null;

	return (
		<nav>
			<ul id={css['aidms-pagination']}>
				<Conditional isVisible={pagination.previousRangeVisible}>
					<PaginationButtonItem
						icon="left"
						onClick={pagination.onPreviousRange}
					/>
				</Conditional>

				{pagination.pagesToDisplay.map((page: number) => (
					<NumberPaginationItem
						key={page}
						isActive={page === props.currentPage}
						page={page}
						onClick={() => props.onPageChange(page)}
					/>
				))}

				<Conditional isVisible={pagination.nextRangeVisible}>
					<PaginationButtonItem icon="right" onClick={pagination.onNextRange} />
				</Conditional>
			</ul>
		</nav>
	);
};

const PaginationButtonItem: React.FC<models.PaginationButton> = (props) => {
	return (
		<li className={css['aidms-page-item']}>
			<button className={css['aidms-page-link']} onClick={props.onClick}>
				<i className={'bi bi-chevron-double-' + props.icon}></i>
			</button>
		</li>
	);
};

const NumberPaginationItem: React.FC<models.PaginationButton> = (props) => {
	return (
		<li
			className={
				props.isActive
					? css['aidms-page-item'] + ' ' + css['active-page']
					: css['aidms-page-item']
			}
		>
			<button className={css['aidms-page-link']} onClick={props.onClick}>
				{props.page}
			</button>
		</li>
	);
};

export default Pagination;
